import { render, staticRenderFns } from "./ViewsPop.vue?vue&type=template&id=4011ccf5&scoped=true&"
import script from "./ViewsPop.vue?vue&type=script&lang=js&"
export * from "./ViewsPop.vue?vue&type=script&lang=js&"
import style0 from "./ViewsPop.vue?vue&type=style&index=0&id=4011ccf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011ccf5",
  null
  
)

export default component.exports